export enum OnboardingStatuses {
  NOT_YET = "NOT_YET",
  ONBOARDING = "ONBOARDING",
  ONBOARDED = "ONBOARDED",
}
